module.exports = __webpack_public_path__ + "assets/img/Gourmet-Basket-eBook.f704496f.webp";